module.exports = __webpack_public_path__ + "img/count_down2.87c7bc90.png";